import { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "@/gql";

export type RelocationPageListItem = ResultOf<
  typeof relocationPageListQuery
>["relocationPages"]["data"][number];

export const relocationPageListQuery = graphql(`
  query RelocationPages(
    $page: Int!
    $first: Int!
    $orderBy: [QueryRelocationPagesOrderByOrderByClause!]
    $search: String
  ) {
    relocationPages(
      first: $first
      page: $page
      orderBy: $orderBy
      search: $search
    ) {
      data {
        id
        slug
        description
        title
        points {
          lat
          lng
          radius
        }
        created_at
        updated_at
        image {
          ...MediaFields
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
